import { render, staticRenderFns } from "./DisplayInfoComponent.vue?vue&type=template&id=4c06624d&scoped=true&"
import script from "./DisplayInfoComponent.vue?vue&type=script&lang=ts&"
export * from "./DisplayInfoComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c06624d",
  null
  
)

export default component.exports